import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { func } from 'prop-types';

import { Carousel } from '@snapask/common-components';

import styles from './InteractiveTimeline.scss';

const cx = require('classnames/bind').bind(styles);

const groupByYear = arr =>
  arr.reduce((groups, item) => {
    const val = item.year;
    groups[val] = groups[val] || []; // eslint-disable-line
    groups[val].push(item);

    return groups;
  }, {});

class InteractiveTimeline extends Component {
  static propTypes = {
    t: func.isRequired,
  };

  constructor(props) {
    super(props);
    this.sliderPoints = [];
    this.state = {
      points: [],
      currentPoint: 0,
      currentIndex: 0,
      mobileIndex: 0,
    };
  }

  componentDidMount = () => {
    const timelineWidth = this.timeline.offsetWidth;
    let tempWidth = 0;
    const points = [];

    this.sliderPoints.forEach(point => {
      const pointWidth = point.offsetWidth;
      const midPoint = pointWidth / 2;
      points.push(
        ((midPoint + tempWidth) / timelineWidth) * 100 || timelineWidth
      );
      tempWidth += pointWidth;
    });

    if (points.length) {
      this.setState({
        currentPoint: points[0],
        points,
      });
    }
  };

  onClickPoint = currentIndex => {
    this.setState({
      currentPoint: this.state.points[currentIndex],
      currentIndex,
    });
  };

  onChangeTimeline = event => {
    const { value } = event.target;
    const { points } = this.state;
    if (value === 0) {
      this.setCurrentPoint(points[0], 0);

      return;
    }
    if (value >= points[points.length - 1]) {
      this.setCurrentPoint(points[points.length - 1], points.length - 1);

      return;
    }
    for (let i = 0, length = points.length; i < length; i++) {
      const lowerValue = points[i];
      const upperValue = i + 1 <= points.length - 1 ? points[i + 1] : 100;
      if (value === lowerValue) {
        this.setCurrentPoint(lowerValue, i);
        break;
      }
      if (value === upperValue) {
        this.setCurrentPoint(upperValue, i + 1);
        break;
      }
      if (value > lowerValue && value < upperValue) {
        if (value - lowerValue <= upperValue - value) {
          this.setCurrentPoint(lowerValue, i);
          break;
        } else {
          this.setCurrentPoint(upperValue, i + 1);
          break;
        }
      }
    }
  };

  onClickMobilePoint = mobileIndex => {
    this.setState({
      mobileIndex,
    });

    this.sliderWrapper.slider.slickGoTo(mobileIndex);
  };

  onChangeSlide = mobileIndex => {
    this.setState({
      mobileIndex,
    });
  };

  setCurrentPoint = (currentPoint, currentIndex) => {
    this.setState({
      currentPoint,
      currentIndex,
    });
  };

  renderTimeline = TIMELINE_DATA => {
    let lastYear;

    return (
      <div
        className={styles.timeline}
        ref={timeline => {
          this.timeline = timeline;
        }}
      >
        {TIMELINE_DATA.map((event, index) => {
          const { year } = event;
          const currentYear = year;
          const isActive = index === this.state.currentIndex;

          if (lastYear !== currentYear) {
            lastYear = currentYear;

            return (
              <div
                ref={point => {
                  this.sliderPoints.push(point);
                }}
                key={index}
                className={cx(styles.pointContainer, isActive && 'active')}
              >
                {isActive && <div className={styles.anchorBlock} />}
                <span className={styles.date}>{currentYear}</span>
                <div
                  className={styles.yearPoint}
                  onClick={() => this.onClickPoint(index)}
                />
              </div>
            );
          }

          return (
            <div
              ref={point => {
                this.sliderPoints.push(point);
              }}
              key={index}
              className={cx(styles.pointContainer, isActive && 'active')}
            >
              {isActive && <div className={styles.anchorBlock} />}
              <div
                className={styles.point}
                onClick={() => this.onClickPoint(index)}
              />
            </div>
          );
        })}
      </div>
    );
  };

  renderSlideShow = (year, index) => {
    const { t } = this.props;
    const TIMELINE_DATA = t('mission.sectionSix.timeline', {
      returnObjects: true,
      defaultValue: [],
    });

    const groupedData = groupByYear(TIMELINE_DATA);
    const dataArr = groupedData[year];
    const users = dataArr[dataArr.length - 1].users;

    return (
      <div className={styles.card} key={index}>
        <div className={styles.top}>
          <p className={styles.blue}>{t('mission.sectionSix.usersNumber')}</p>
          <h2>{`${users.toLocaleString()} +`}</h2>
        </div>
        <div className={styles.bottom}>
          {dataArr.map((currentMonth, index) => (
            <div key={index} className={styles.singleMonth}>
              <p className={styles.blue}>{currentMonth.month}</p>
              <p className={styles.large}>{currentMonth.description}</p>
            </div>
          ))}
        </div>
      </div>
    );
  };

  renderMobileDots = (year, index) => (
    <div
      key={index}
      className={cx('pointContainer', {
        active: index === this.state.mobileIndex,
      })}
    >
      <span className={styles.date}>{year}</span>
      <div
        className={styles.yearPoint}
        onClick={() => this.onClickMobilePoint(index)}
      />
    </div>
  );

  render() {
    const { t } = this.props;
    const { currentPoint, currentIndex, mobileIndex } = this.state;

    const TIMELINE_DATA = t('mission.sectionSix.timeline', {
      returnObjects: true,
      defaultValue: [],
    });
    const currentTimeLinData = TIMELINE_DATA[currentIndex] || {};

    const groupedData = groupByYear(TIMELINE_DATA);

    return (
      <div className={styles.root}>
        <div className={styles.desktop}>
          <div className={styles.card}>
            <div className={styles.top}>
              <p className={styles.blue}>
                {t('mission.sectionSix.usersNumber')}
              </p>
              <h1>
                {!!currentTimeLinData.users &&
                  `${currentTimeLinData.users.toLocaleString()} +`}
              </h1>
            </div>
            <div className={styles.bottom}>
              <p className={styles.blue}>
                {!!currentTimeLinData.month && currentTimeLinData.month}
              </p>
              <p className={styles.large}>
                {!!currentTimeLinData && currentTimeLinData.description}
              </p>
            </div>
          </div>
          <div className={styles.spacer} />
          <div className={styles.timelineContainer}>
            <span className={styles.graphAxis}>
              {t('mission.sectionSix.yAxis')}
            </span>
            <div className={styles.graph}>
              <div className={styles.mountainOne} />
              <div className={styles.mountainTwo} />
              <div className={styles.gradient} />
            </div>
            <div className={styles.rangeBox}>
              {this.renderTimeline(TIMELINE_DATA)}
              <div className={styles.bottomRangeContainer}>
                <input
                  type="range"
                  min={0}
                  max={100}
                  value={currentPoint}
                  onChange={this.onChangeTimeline}
                  className={styles.bottomRange}
                />
                <div className={styles.dummyRange}>
                  <div
                    className={styles.slider}
                    style={{
                      left: `calc(${currentPoint}% - 8px)`,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.mobile}>
          <div className={styles.timelineContainer}>
            <div className={styles.timeline}>
              {Object.keys(groupedData).map(this.renderMobileDots)}
            </div>
          </div>
          <div className={styles.slideShow}>
            <Carousel
              ref={slider => {
                this.sliderWrapper = slider;
              }}
              settings={{
                className: styles.sliderContainer,
                initialSlide: mobileIndex,
                afterChange: this.onChangeSlide,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                arrows: false,
                dots: true,
              }}
            >
              {Object.keys(groupedData).map(this.renderSlideShow)}
            </Carousel>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('mission')(InteractiveTimeline);



// WEBPACK FOOTER //
// ./app/containers/Mission/components/InteractiveTimeline/InteractiveTimeline.jsx